import { render, staticRenderFns } from "./SadasiProspectSaveDialog.vue?vue&type=template&id=fa1d2cde&"
import script from "./SadasiProspectSaveDialog.vue?vue&type=script&lang=js&"
export * from "./SadasiProspectSaveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QSeparator,QForm,QCardSection,QInput,QSelect,QCardActions,QInnerLoading,QSpinner,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QSeparator,QForm,QCardSection,QInput,QSelect,QCardActions,QInnerLoading,QSpinner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
